import ajax from "../assets/images/partners/ajax.png";
import bull from "../assets/images/partners/bull.png";
import detank from "../assets/images/partners/DETANK.png";
import gehl from "../assets/images/partners/gehl.png";
import gf from "../assets/images/partners/gf.png";
import roots from "../assets/images/partners/roots.png";
import simex from "../assets/images/partners/simex.png";
import manitou from "../assets/images/accessoires/manitou.webp";

const partners = [
  {
    Id: "1",
    pImg: ajax,
    subTitle: "Makes Concrete Sense",
    class: "min",
  },
  {
    Id: "4",
    pImg: manitou,
    subTitle: "Manitou Attachments",
    class: "max",
  },
  {
    Id: "5",
    pImg: gehl,
    subTitle: "Works Like You",
    class: "moy",
  },
  {
    Id: "6",
    pImg: gf,
    subTitle: "Accessoires",
    class: "min",
  },
  {
    Id: "7",
    pImg: roots,
    subTitle: " ",
    class: "max",
  },
  {
    Id: "8",
    pImg: simex,
    subTitle: " ",
    class: "",
  },
];

export default partners;
